import React, { useRef } from "react";
import { useVirtualizer } from "@tanstack/react-virtual";

/**
 * Windowed list for large CRM lead collections.
 * Uses dynamic row measurement for expandable cards.
 */
const CrmVirtualList = ({
  items = [],
  renderItem,
  getItemKey,
  estimateSize = 300,
  className = "",
}) => {
  const parentRef = useRef(null);

  const virtualizer = useVirtualizer({
    count: items.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => estimateSize,
    overscan: 5,
  });

  return (
    <div ref={parentRef} className={`crm-virtual-list ${className}`.trim()}>
      <div
        className="crm-virtual-list__inner"
        style={{ height: virtualizer.getTotalSize(), position: "relative", width: "100%" }}
      >
        {virtualizer.getVirtualItems().map((virtualRow) => {
          const item = items[virtualRow.index];
          const key = getItemKey ? getItemKey(item, virtualRow.index) : virtualRow.key;
          return (
            <div
              key={key}
              data-index={virtualRow.index}
              ref={virtualizer.measureElement}
              className="crm-virtual-list__row"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                transform: `translateY(${virtualRow.start}px)`,
              }}
            >
              {renderItem(item, virtualRow.index)}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CrmVirtualList;
